import { AttributeView } from "./AttributeView";
import { RoadStructuresShedsAttributeConvert } from "./RoadStructuresShedsAttributeConvert";

/**
 * 画面タイトル
 */
const VALUE_TITLE = "点検DB（大型カルバート）";

/**
 * 点検データ（大型カルバート）属性変換クラス
 */
export class RoadStructuresCulvertsAttributeConvert extends RoadStructuresShedsAttributeConvert {
  /**
   * 画面用フォーマットに変換
   * ※画面項目がシェッドと同一の為、点検データ（シェッド）属性変換クラスを実行し、タイトルのみ差し替え
   */
  getViewFormatData(): AttributeView {
    const formatData = super.getViewFormatData();
    formatData.title = VALUE_TITLE;
    return formatData;
  }
}
